import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "constants/colors";

export const historyStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      flex: "70%",
      margin: theme.spacing(2),
    },
    right: {
      flex: "30%",
      margin: theme.spacing(0.2),
      backgroundColor: "#fff",
      padding: theme.spacing(2),
    },
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      height: "100%",
      width: "100%",
      paddingTop: 60,
    },
    header: {
      backgroundColor: "#fff",
      borderRadius: 14,
      margin: "0px 29px 15px 0",
      justifyContent: "space-between",
      width: "100%",
      display: "flex",
      height: "13.5vh",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        width: "auto",
      },
    },
    tag: {
      fontFamily: "Montserrat",
      fontSize: 24,
      fontWeight: 300,
      lineHeight: 2.08,
      color: "#757a93",
      marginLeft: "10px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "15px",
        lineHeight: "2.1",
      },
    },
    headerIcon: {
      textAlign: "right",
      [theme.breakpoints.down("xs")]: {
        marginRight: "auto",
      },
    },
    imgHistory: {
      marginTop: "-10px",
      width: "180px",
      [theme.breakpoints.down("xs")]: {
        height: " 64px",
        width: "101px",
        marginLeft: "22px",
        marginTop: "5px",
      },
    },
    body: {
      backgroundColor: "#fff",
      borderRadius: 14,
      marginTop: 20,
      width: "100%",
    },

    headerContainer: {
      display: "flex",
      padding: "10px 22px",
      alignItems: "center",
    },
    headerAction: {
      display: "flex",
      padding: "0px 24px 15px 22px",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        padding: "0px 20px 10px 9px",
      },
    },
    bodyTitle: {
      color: "#1a224b",
      fontSize: 24,
      fontWeight: "bold",
      [theme.breakpoints.down("xs")]: {
        fontSize: "17px",
      },
    },
    filterButton: {
      marginLeft: "auto",
      width: 140,
      [theme.breakpoints.down("xs")]: {
        marginLeft: "auto",
      },
    },
    table: {
      marginLeft: 20,
      width: "96%",
      [theme.breakpoints.down("xs")]: {
        width: "90%",
        marginLeft: "7px",
      },
    },
    actionStyle: {
      marginLeft: 20,
    },

    gridContainer: {
      height: "13vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("xs")]: {
        height: "auto",
      },
    },

    reloadButton: {
      backgroundColor: COLORS.orange,
      color: COLORS.white,
      height: "25px",
      fontWeight: 600,
    },
    searchDateHistory: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "14px",
    },
    searchDropOff: {
      alignItems: "center",
      border: "solid 0.5px #faecca",
      borderRadius: 10,
      display: "flex",
      height: 64,
      marginRight: 20,
      [theme.breakpoints.down("xs")]: {
        margin: "8px",
      },
    },
    searchFromStock: {
      alignItems: "center",
      border: "solid 0.5px #b0cef1",
      borderRadius: 10,
      height: 64,
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        margin: "8px",
      },
    },
    searchPickup: {
      alignItems: "center",
      border: "solid 0.5px #e3f8fa",
      borderRadius: 10,
      height: 64,
      display: "flex",
      marginRight: 20,
      [theme.breakpoints.down("xs")]: {
        margin: "8px",
      },
    },
    subTitle: {
      marginBottom: 21,
      marginTop: 21,
    },
    fieldDateFrom: { background: "red" },
    typographyStyled: {
      paddingLeft: "14px",
    },
    textField: {
      width: "24rem",
    },
    modalStyled: {
      width: "3rem",
    },
    gridStyled: {
      marginTop: "20px",
    },
    btnExport: {
      margin: "7px",
    },
  })
);
